import {useEffect, useState} from 'react'

const DELAY_CONST = 500

export const useDebouncedCallback = (callback, delay = DELAY_CONST) => {
  const [timeoutId, setTimeoutId] = useState(null)

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [timeoutId])

  const debouncedCallback = (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    const newTimeoutId = setTimeout(() => {
      callback(...args)
    }, delay)

    setTimeoutId(newTimeoutId)
  }

  return debouncedCallback
}
